require('./angular-touch');
module.exports = 'ngTouch';



//////////////////
// WEBPACK FOOTER
// ./~/angular-touch/index.js
// module id = 125
// module chunks = 14